import { Alert as AntdAlert, AlertProps } from 'antd';
import { useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import useAlertState from '../../../modules/ui/hooks/use-alert-state';
import { closeAlert } from '../../../modules/ui/store/ui-slice';
import styles from './alert.module.css';
import { CloseIcon } from '../../icons/close-icon';

interface Props extends AlertProps {
  alertId: string;
}

const Alert = ({ alertId, ...props }: Props): JSX.Element => {
  const message = useAlertState(alertId);
  const dispatch = useDispatch();
  const messageRef = useRef<HTMLDivElement>(null);
  const [timerId, setTimerId] = useState<ReturnType<typeof setTimeout> | null>(null);

  useEffect(() => {
    if (messageRef.current) {
      window.scrollTo({
        top: 64,
        behavior: 'smooth',
      });
    }

    if (Object.keys(message).length) {
      if (timerId !== null) {
        clearTimeout(timerId);
      }

      const newTimerId = setTimeout(() => {
        dispatch(closeAlert({ id: alertId }));
      }, 5000);

      setTimerId(newTimerId);
    }

    return () => {
      if (timerId !== null) {
        clearTimeout(timerId);
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [message, alertId, dispatch]);

  return Object.keys(message).length ? (
    <div className={styles.container} ref={messageRef}>
      <AntdAlert
        className={styles.antdAlertCustomStyling}
        {...message}
        closable={{ closeIcon: <CloseIcon />, afterClose: () => dispatch(closeAlert({ id: alertId })) }}
        {...props}
      />
    </div>
  ) : (
    <div />
  );
};

export default Alert;
